import React, { FC } from 'react';
import styled from 'styled-components';
import Flex from 'Components/Grid/Flex';
import LogoIcon from 'Components/Header/Logo/LogoIcon';
import SloganIcon from 'assets/images/slogan.svg';
import { colors } from 'constants/colors';
import { mediaSmDown } from 'theme/helpers/css';
import { Box } from '@igooods/ui-kit';

export const LANDING_LOGO_SLOGAN_TEST_ID = 'LANDING_LOGO_SLOGAN_TEST_ID';

export const Logo = styled(LogoIcon)`
  max-width: 140px;
  height: auto;
  margin-right: 20px;

  ${mediaSmDown`
    max-width: 80px;
    margin-right: 0;
  `}
`;

const Separator = styled(Box).attrs({ hideBefore: 'sm' })`
  height: 23px;
  border-right: 1px solid ${colors.darkBlueGreen};
  transform: rotate(20deg);
`;

const Slogan = styled(Box).attrs({ hideBefore: 'sm', ml: 5 })`
  width: 58px;
  height: 27px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${SloganIcon});
`;

const LogoWithSlogan: FC = () => {
  return (
    <Flex notShrink middle>
      <Logo />
      <Separator />
      <Slogan data-testid={LANDING_LOGO_SLOGAN_TEST_ID} />
    </Flex>
  );
};

export default LogoWithSlogan;
